var render = function render(){var _vm=this,_c=_vm._self._c;return _c('theme-comp-switch',{attrs:{"defaultComp":_vm.defaultErrorPage,"lalamoveComp":_vm.lalamoveErrorPage}},[_c('div',[_vm._v(_vm._s(_vm.$t('act_access_error')))]),_c('div',{staticClass:"errorTip"},[_vm._v(_vm._s(_vm.$t('act_access_error_tip')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }